import React, { useState, useEffect } from "react";
import Sidebar from "@/components/Sidebar";
import Header from "@/components/Header";
import StatCard from "@/components/StatCard";
import RequestChart from "@/components/SiteTrafficChart";
import SupplierChart from "@/components/WeeklySalesChart";
import OrdersSummary from "@/components/OrdersSummary";
import SocialStatsCard from "@/components/SocialStatsCard";
import EarningsCard from "@/components/EarningsCard";
import CustomerReviews from "@/components/CustomerReviews";
import WeeklyRequestStatus from "@/components/WeeklyRequestStatus";
import UserSupplierList from "@/components/UserSupplierList";
import { Settings, Facebook, Twitter, Youtube } from "lucide-react";
import { getDashboardStats } from "@/api/dashboard";

const Index = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [stats, setStats] = useState({
    totalRequests: 0,
    totalUsers: 0,
    totalSuppliers: 0,
    totalProducts: 0,
    totalSites: 0,
    percentageChanges: {
      requests: "0%",
      users: "0%",
      suppliers: "0%",
      products: "0%",
      sites: "0%",
    },
    latestRequests: [],
    latestUsers: [],
    latestSuppliers: [],
  });

  useEffect(() => {
    const fetchStats = async () => {
      const data = await getDashboardStats();
      setStats(data);
    };

    fetchStats();
  }, []);

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar collapsed={sidebarCollapsed} onToggle={toggleSidebar} />

      <div className="flex-1 flex flex-col overflow-hidden">
        <Header onToggleSidebar={toggleSidebar} />

        <main className="flex-1 overflow-x-hidden overflow-y-auto p-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 mb-6">
            <StatCard
              type="orders"
              title="Total Requests"
              value={stats.totalRequests.toString()}
              percentage={stats.percentageChanges.requests}
            />
            <StatCard
              type="visitors"
              title="Total Users"
              value={stats.totalUsers.toString()}
              percentage={stats.percentageChanges.users}
            />
            <StatCard
              type="revenue"
              title="Total Suppliers"
              value={stats.totalSuppliers.toString()}
              percentage={stats.percentageChanges.suppliers}
            />
            <StatCard
              type="products"
              title="Total Products"
              value={stats.totalProducts.toString()}
              percentage={stats.percentageChanges.products}
            />
            <StatCard
              type="sites"
              title="Total Sites"
              value={stats.totalSites.toString()}
              percentage={stats.percentageChanges.sites}
            />
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-6">
            <div className="lg:col-span-2">
              <RequestChart />
            </div>
            <div>
              <SupplierChart />
            </div>
          </div>

          {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
            <SocialStatsCard
              platform="facebook"
              title="Facebook Followers"
              percentage={60}
              change="22.14%"
              icon={<Facebook className="w-5 h-5 text-[#4267B2]" />}
            />
            <SocialStatsCard
              platform="twitter"
              title="Twitter Tweets"
              percentage={65}
              change="32.15%"
              icon={<Twitter className="w-5 h-5 text-[#1DA1F2]" />}
            />
            <SocialStatsCard
              platform="youtube"
              title="Youtube Subscribers"
              percentage={75}
              change="58.24%"
              icon={<Youtube className="w-5 h-5 text-[#FF0000]" />}
            />
          </div> */}

          {/* <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-6">
            <div>
              <EarningsCard
                totalEarning="$287,493"
                earningChange="1.4%"
                totalSales="$87,493"
                salesChange="5.43%"
                chartData={[65, 45, 55, 70, 35, 45, 55, 45, 65, 40, 45]}
              />
            </div>
            <div className="lg:col-span-2">
              <CustomerReviews
                reviews={[
                  {
                    id: 1,
                    userName: "Sara Jhon",
                    productName: "iPhone X",
                    review: "This is svery Nice phone in low budget.",
                    rating: 3,
                    time: "08.34 AM",
                    avatar: "/avatars/avatar1.jpg",
                  },
                  {
                    id: 2,
                    userName: "Danish Josh",
                    productName: "Air Pod",
                    review: "The brand apple is original !",
                    rating: 3,
                    time: "05.26 PM",
                    avatar: "/avatars/avatar2.jpg",
                  },
                  {
                    id: 3,
                    userName: "Jhon Doe",
                    productName: "Mackbook Pro",
                    review: "Excllent product and awsome quality",
                    rating: 3,
                    time: "06.45 AM",
                    avatar: "/avatars/avatar3.jpg",
                  },
                  {
                    id: 4,
                    userName: "Christine",
                    productName: "Air Pod",
                    review: "The brand apple is original !",
                    rating: 3,
                    time: "08.34 AM",
                    avatar: "/avatars/avatar4.jpg",
                  },
                  {
                    id: 5,
                    userName: "Michle",
                    productName: "Mackbook",
                    review: "The brand apple is original !",
                    rating: 3,
                    time: "08.34 AM",
                    avatar: "/avatars/avatar5.jpg",
                  },
                ]}
              />
            </div>
          </div> */}

          <div className="mb-6">
            <OrdersSummary />
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-6">
            <div className="lg:col-span-3">
              <UserSupplierList
                users={stats.latestUsers}
                suppliers={stats.latestSuppliers}
              />
            </div>
          </div>
        </main>

        <footer className="bg-white p-4 text-center text-gray-500 text-sm border-t">
          Copyright © 2021. All right reserved.
        </footer>
      </div>

      <div className="fixed bottom-4 right-4">
        <button className="bg-blue-600 text-white p-3 rounded-full shadow-lg hover:bg-blue-700 transition-colors">
          <Settings size={24} />
        </button>
      </div>
    </div>
  );
};

export default Index;
